// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__zxzxd","inner":"styles_inner__pY7Cq","disabled":"styles_disabled__YNR5B","label":"styles_label__eyxx0","input":"styles_input__E8Xhu"};